import { defineStore } from 'pinia';
import to from 'await-to-js';
import { store } from '/@/store';
import { apis } from '/@/apis';

type AutoConvertInfo = NonNullable<
  Awaited<ReturnType<typeof apis.autoConvert.getWebsiteAutoConvertInfo>>['info']
>;

interface AutoConvertState {
  gray: boolean;
  info: AutoConvertInfo | null;
  fetching: boolean;
}

export const useAutoConvertStore = defineStore({
  id: 'auto-convert',
  state: (): AutoConvertState => ({
    gray: false,
    info: null,
    fetching: false,
  }),
  getters: {
    /** 是否需要扫码引导 */
    needScan(): boolean {
      if (!this.gray) {
        return false;
      }
      if (this.info?.pod || this.info?.converted || this.info?.batch) {
        return false;
      }
      return this.info?.scan === false;
    },
    /** 是否需要完善资料 */
    needCompleteForm(): boolean {
      if (!this.gray) {
        return false;
      }
      if (this.info?.pod || this.info?.converted) {
        return false;
      }
      return this.info?.form === false;
    },
    /** 是否未转化 （试用用户） */
    isNotConverted(): boolean {
      return this.info?.pod === true && this.info?.converted === false;
    },
  },
  actions: {
    reset() {
      this.info = null;
    },

    async getAutoConvertInfo() {
      if (this.info) {
        return this.info;
      }
      return this.updateAutoConvertInfo();
    },

    async updateAutoConvertInfo() {
      if (this.fetching) {
        return await new Promise<AutoConvertInfo | null>((resolve) => {
          this.$subscribe(() => {
            if (!this.fetching) {
              resolve(this.info);
            }
          });
        });
      }

      this.fetching = true;
      const [err, res] = await to(apis.autoConvert.getWebsiteAutoConvertInfo());
      this.info = err ? null : res?.info ?? null;
      this.gray = res?.gray ?? false;
      this.fetching = false;
      return this.info;
    },
  },
});

export function useAutoConvertStoreWithOut() {
  return useAutoConvertStore(store);
}
